import CryptoJS from 'crypto-js';

var KEY = 'DC7E5F5666494EA49B149919C0E1F0F7';

/** 加密 */
export function aesEncrypt(word) {
  return CryptoJS.AES.encrypt(word, CryptoJS.enc.Utf8.parse(KEY), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
}

/** 解密 */
export function aesDecrypt(word) {
  return CryptoJS.AES.decrypt(word, CryptoJS.enc.Utf8.parse(KEY), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
}
